export const apiHost = {
    // baseURL: "https://mis.daqi.in/"
    // baseURL: "https://dev-mis-api.daqi.in/"
    baseURL: "https://dev-ecs-mis.daqi.in/"
};